export const PRODUCT_STATUS = {
	ALL: 'all',
	ACTIVE: 'active',
	INACTIVE: 'inactive',
};

export const PRODUCT_STATUS_OPTIONS = [
	{
		label: 'All',
		value: PRODUCT_STATUS.ALL,
	},
	{
		label: 'Active',
		value: PRODUCT_STATUS.ACTIVE,
	},
	{
		label: 'Inactive',
		value: PRODUCT_STATUS.INACTIVE,
	},
];

export const DEFAULT_PRODUCT_STATUS = PRODUCT_STATUS_OPTIONS.find(
	(option) => option.value === PRODUCT_STATUS.ACTIVE,
);

export const PRODUCT_CHART_WRAPPER_HEIGHT = 600;
export const PRODUCT_SELECT_MAX_HEIGHT = '52px';
